import { Button } from 'antd'
import ModalCustom from './modal-custom'
import { Text, Text3 } from './custom/Typography'
import IconWarning from '../images/warning2.svg'
import { Image } from 'react-bootstrap'

export default function ModalAlert({
  open,
  icon,
  iconBg = 'var(--color-primary-foreground-subtle)',
  title,
  titleColor = 'var(--color-on-base-content-high)',
  description,
  descColor = 'var(--color-on-base-content-default)',

  okText = 'OK',
  cancelText,

  okType = 'primary',
  okStyle,
  cancelStyle,

  onOk,
  onCancel,
  width = 391,
}) {
  return (
    <ModalCustom
      open={open}
      closable={false}
      maskClosable={false}
      keyboard={false}
      width={width}
      onCancel={onCancel || onOk}
      footer={
        <div className="d-flex gap-2 mt-4">
          {cancelText && (
            <Button size="large" block style={cancelStyle} onClick={onCancel}>
              {cancelText}
            </Button>
          )}

          <Button
            type={okType}
            size="large"
            block
            style={okStyle}
            onClick={onOk}
          >
            {okText}
          </Button>
        </div>
      }
    >
      <div className="text-center">
        <div
          className="d-inline-flex align-items-center justify-content-center mb-4"
          style={{
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: iconBg,
          }}
        >
          <Image src={IconWarning} style={{ width: '74px' }} />
          {/* <IconWarning style={{ width: '74px' }} /> */}
        </div>
        {/* {icon && (
          <div
            className="d-inline-flex align-items-center justify-content-center mb-4"
            style={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              background: iconBg,
            }}
          >
            {icon}
          </div>
        )} */}

        {title && (
          <Text3
            size="20px"
            className="mb-2"
            style={{ color: titleColor, fontWeight: 700 }}
          >
            {title}
          </Text3>
        )}

        {description && (
          <Text size="16px" style={{ color: descColor }}>
            {description}
          </Text>
        )}
      </div>
    </ModalCustom>
  )
}
